import type { FC } from "react";
import { CheckedIcon, IconWrapper, StyledListIntroItem, StyledListIntroItemText } from "./styles";

type ListItemProp = {
    text: string;
};
const IntroductionViewListItem: FC<ListItemProp> = ({ text }) => {
    return (
        <StyledListIntroItem>
            <IconWrapper>
                <CheckedIcon />
            </IconWrapper>
            <StyledListIntroItemText>{text}</StyledListIntroItemText>
        </StyledListIntroItem>
    );
};

export default IntroductionViewListItem;
